"use strict";
import { ENS_SUFFIX } from "features/ens/constants";
import { UNITAG_SUBDOMAIN, UNITAG_SUFFIX } from "features/unitags/constants";
export var SearchResultType = /* @__PURE__ */ ((SearchResultType2) => {
  SearchResultType2[SearchResultType2["ENSAddress"] = 0] = "ENSAddress";
  SearchResultType2[SearchResultType2["Token"] = 1] = "Token";
  SearchResultType2[SearchResultType2["Etherscan"] = 2] = "Etherscan";
  SearchResultType2[SearchResultType2["NFTCollection"] = 3] = "NFTCollection";
  SearchResultType2[SearchResultType2["Unitag"] = 4] = "Unitag";
  SearchResultType2[SearchResultType2["WalletByAddress"] = 5] = "WalletByAddress";
  SearchResultType2[SearchResultType2["Pool"] = 6] = "Pool";
  return SearchResultType2;
})(SearchResultType || {});
export function isTokenSearchResult(x) {
  return x.type === 1 /* Token */;
}
export function isPoolSearchResult(x) {
  return x.type === 6 /* Pool */;
}
export function isNFTCollectionSearchResult(x) {
  return x.type === 3 /* NFTCollection */;
}
export function isEtherscanSearchResult(x) {
  return x.type === 2 /* Etherscan */;
}
export function isWalletSearchResult(x) {
  return x.type === 5 /* WalletByAddress */ || x.type === 0 /* ENSAddress */ || x.type === 4 /* Unitag */;
}
export function extractDomain(walletName, type) {
  const index = walletName.indexOf(".");
  if (index === -1 || index === walletName.length - 1) {
    return type === 4 /* Unitag */ ? UNITAG_SUFFIX : ENS_SUFFIX;
  }
  const domain = walletName.substring(index);
  return domain === UNITAG_SUBDOMAIN ? UNITAG_SUFFIX : domain;
}
